import React, { useContext } from 'react'
import 'fontsource-roboto'
import './App.css'
import { ConfigContext, COIN, USDT, BUSD } from './context/ConfigProvider'
import FundingTable from './tables/FundingTable'
import Collect from './components/Collect';


function Funding() {

  const  { config, Styles } = useContext(ConfigContext)

  return (
    <Styles>
      <Collect name="funding" />
      <br></br><br></br><br></br><br></br>
      {
        config.symbols.map((symbol) => (
          <React.Fragment key={symbol.symbol}>
            <br></br>
            <FundingTable symbol={symbol.symbol} types={[COIN,USDT,BUSD]} />
            <br></br>
          </React.Fragment>
        ))
      }
    </Styles>
  )
  
}

export default Funding